import { Tooltip, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { getBgColor } from '../utils/utils';
import { useSelector } from 'react-redux';

const GridComponent = ({
  title,
  data,
  roundIfFloat,
  metric,
  clarityDatas,
  allClarityRanges,
  colorKeys,
  min,
  max,
  invertColors = false,
  onCellClick,
  hoveredCell,
  onCellHover,
  defaultTurn,
  handleCellClick,
  isChangingShapeOrCarat,
  setIsChangingGrading,
  getCellStyle
}) => {

  const {
      selectedCell
    } = useSelector((state) => state.colorClarity); 
  // if(data?.data){
  //   setTimeout(() => {
  //     setIsChangingGrading(false);
  //   }, 500);
  // }

  function roundIfFloatZero(value) {
    // Check if the value is a number and if it has a decimal part
    if (typeof value === 'number' && value % 1 !== 0) {
      // Round the number to 0 decimal places
      return Math.round(value);
    }
    // Return the value as it is if it's not a float
    return value;
  }
  

  return (
    <div className="flex flex-col ">
      <h3 className="text-center text-inherit text-2xl font-medium">{title}</h3>
      {data ? (
        <div className="w-[600px]">
          <table className="higher-level-shape-size self-center">
            <thead style={{ zIndex: 1 }}>
              <tr className="bg-gray-200">
                <th style={{ width: '55px' }} className="border border-gray-300">
                  Col / Clar
                </th>
                {colorKeys.length > 0 &&
                  Object.keys(data?.data[colorKeys[0]] || {})
                    .filter((key) => key !== 'trans')
                    .map((clarity) => (
                      <th key={clarity}>
                        {data?.data[colorKeys[0]][clarity]?.trans || clarity}
                      </th>
                    ))}
              </tr>
            </thead>
            <tbody>
              {colorKeys.map((color, rowIndex) => (
                <tr key={color}>
                  <td style={{ cursor: 'pointer' }}>
                    {data?.data[color]?.trans}
                  </td>
                  {allClarityRanges.map((clarity, colIndex) => {
                    const cellData = clarityDatas[rowIndex][colIndex][metric];
                    const cellBracketData = clarityDatas[rowIndex][colIndex]['prr_count'];
                    const cellAvgBracketData = clarityDatas[rowIndex][colIndex]['prr_avg_market_count'];
                    const cellRankBracketData = clarityDatas[rowIndex][colIndex]['prr_avg_rank'];

                    const minMetric = Math.min(...clarityDatas.flat().map((cell) => cell[metric]));
                    const maxMetric = Math.max(...clarityDatas.flat().map((cell) => cell[metric]));

                    let neutralValue = 0;
                    let localInvertColors = invertColors;

                    if (title === 'Aging') {
                      neutralValue = 365 / defaultTurn;
                      localInvertColors = true;
                    }

                    const bgColor = getBgColor(minMetric, maxMetric, cellData, neutralValue, 50, localInvertColors);
                    const isHighlighted =
                      hoveredCell && hoveredCell.column === colIndex && hoveredCell.row === rowIndex;

                    const tooltipContent = (
                      <>
                        <div className="flex justify-between w-max items-center" style={{ width: '124px' }}>
                          <div className="w-max">Avg Rank:</div>
                          <div className="text-left">
                            <strong>{roundIfFloat(cellRankBracketData)}</strong>
                          </div>
                        </div>
                        <div className="flex w-max justify-between items-center" style={{ width: '124px' }}>
                          <div className="w-max">Avg Market Count:</div>
                          <div className="text-left">
                            <strong>{roundIfFloat(cellAvgBracketData)}</strong>
                          </div>
                        </div>
                        <div className="flex w-max justify-between items-center" style={{ width: '124px' }}>
                          <div className="w-max">Rank Percentile:</div>
                          <div className="text-left">
                            <strong>{clarityDatas[rowIndex][colIndex].rank_distribution}</strong>
                          </div>
                        </div>
                        <div className="flex w-max justify-between items-center" style={{ width: '124px' }}>
                          <div className="w-max">Rank Movement:</div>
                          <div className="text-left">
                            <strong>{roundIfFloatZero(clarityDatas[rowIndex][colIndex].rank_movement)}</strong>
                          </div>
                        </div>
                        <div className="flex w-max justify-between items-center" style={{ width: '124px' }}>
                          <div className="w-max">Aging:</div>
                          <div className="text-left">
                            <strong>{clarityDatas[rowIndex][colIndex].aging}</strong>
                          </div>
                        </div>
                        <div className="flex w-max justify-between items-center" style={{ width: '124px' }}>
                          <div className="w-max">Stock Count:</div>
                          <div className="text-left">
                            <strong>{cellBracketData}</strong>
                          </div>
                        </div>
                      </>
                    );

                    return (
                      <Tooltip
                        key={`${clarity}-${color}`}
                        title={tooltipContent}
                        arrow
                        placement="right-start"
                        disableInteractive
                      >
                        <td
                          key={clarity}
                          style={{
                            height: '43.3px',
                            minWidth: '48.4px',
                            padding: '0',
                            margin: '0 auto',
                            border: (selectedCell?.color === color && selectedCell?.clarity === clarity) ? "2px solid #000" : "1px solid #ccc",
                            maxWidth: '55px',
                            backgroundColor: bgColor,
                            outline: isHighlighted ? '1px solid black' : 'none',
                            outlineOffset: '-1px',
                            boxShadow: 'none',
                            fontWeight: 'normal',
                          }}
                          onClick={() =>
                              handleCellClick(
                                color,
                                clarity,
                              )
                            }
                          onMouseEnter={() => onCellHover(colIndex, rowIndex)}
                          onMouseLeave={() => onCellHover(null, null)}
                        >
                          {metric === 'aging' ? (roundIfFloat(cellData) == 0 && cellBracketData == 0)? "-" : (
                            <>
                              <div style={{ textDecoration: 'underline' }}>{roundIfFloat(cellData)}</div>
                              <div style={{ fontSize: '9px' }}>{cellBracketData}</div>
                            </>
                          ) : metric === 'rank_distribution' ? (roundIfFloat(cellRankBracketData) == 0 && cellAvgBracketData == 0)? "-" : (
                            <>
                              <div style={{ textDecoration: 'underline' }}>{roundIfFloat(cellRankBracketData)}</div>
                              <div style={{ fontSize: '9px' }}>{roundIfFloat(cellAvgBracketData)}</div>
                            </>
                          ) : metric === 'rank_movement' && roundIfFloatZero(cellData) == 0 && (roundIfFloat(cellRankBracketData) == 0 && cellAvgBracketData == 0) ? '-' : (
                            roundIfFloatZero(cellData)
                          )}
                        </td>
                      </Tooltip>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <Typography>No data available for this selection.</Typography>
      )}
    </div>
  );
};

export default GridComponent;
